import DataTable from "Components/molecule/data-table";
import { ColumnDef, Table } from "@tanstack/react-table"
import ClientProjectFinance from "models/project-finance";
import ActionButton from "Components/atoms/buttons/action-button";
import { useState } from "react";
import Project from "models/project";
import ErrorState from "../error-state";
import PrimaryButton from "Components/atoms/buttons/primary-button";
import SecondaryButton from "Components/atoms/buttons/secondary-button";


type FinancialAndForecastingSummaryRow = {
    __rowType: 'summary',
    plannedAmount: number
    actualAmount?: number
    forecastAmount: number
}

type ClientProjectFinanceRow = ClientProjectFinance & { __rowType: "client-project-finance" }

export type FinancialAndForecastingRow = ClientProjectFinanceRow | FinancialAndForecastingSummaryRow

interface FinancialsAndForecastingProps {
    table: Table<FinancialAndForecastingRow>
    column: ColumnDef<FinancialAndForecastingRow>[]
    project: Project
    handleSave: () => Promise<any>
    handleReset: () => Promise<any>
    controlsId: string
}


const FinancialsAndForecasting = ({
    table,
    column,
    project,
    handleSave,
    handleReset,
    controlsId
}: FinancialsAndForecastingProps) => {
    const [saving, setSaving] = useState<boolean>(false)



    const onSave = async () => {
        setSaving(true)
        await handleSave()
        setSaving(false)
    }

    return <div className="finacials-and-forecasting">
        <div className="title">
            <div>
                <h4>Monthly Financials & Forecasting</h4>
                <span>Track actial spend against baseline and update monthly forecasts.</span>
            </div>
            <div>
                <div id={controlsId} style={{ display: 'none' }}>
                    <PrimaryButton
                        disabled={saving}
                        onClick={onSave}
                        style={{ minWidth: '100px' }}
                    >{saving ? 'Saving...' : "Save"}
                    </PrimaryButton>
                    <SecondaryButton
                        style={{
                            marginLeft: '10px'
                        }}
                        onClick={handleReset}
                    >
                        Reset
                    </SecondaryButton>
                </div>
            </div>
        </div>
        <br />
        <div className="data">
            {
                !project.endDate && table.getRowModel().rows.length === 0
                    ?
                    <ErrorState
                        title={"Project end date not found"}
                        subtitle={"Project must has an end date to show financials and forecasting"}
                    />
                    :
                    <DataTable
                        table={table}
                        columns={column}
                    />
            }

        </div>
    </div>
}

export default FinancialsAndForecasting;